<script>
    import { logout } from "../http";
    import Icon from "./Icon.svelte";
</script>

<button type="button" class="button" name="logout" id="logout" on:click={logout}>
    <Icon name="logout"/> <span>Wyloguj</span>
</button>
